import styled from '@emotion/styled';
import React, { FC } from 'react';
import { useButton } from '~Hooks';
import { GrayButton } from '~Styles';

const StyledButton = styled(GrayButton)<{ isSelected: boolean }>`
  background: ${(props) => (props.isSelected ? 'var(--colorGradientGreen)' : 'auto')};
  color: ${(props) => (props.isSelected ? 'var(--colorWhite)' : 'auto')};
`;

interface Props {
  reasonEntered: string;
  reason: string;
  onClick: () => void;
}

/** Extracted to its own component to support useButton */
const ReasonButton: FC<Props> = ({ reasonEntered, reason, onClick }) => {
  const btn = useButton({
    onClick: onClick,
  });

  return (
    <StyledButton size="small" isSelected={reasonEntered === reason} {...btn}>
      {reason}
    </StyledButton>
  );
};

export default ReasonButton;
